// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#other-user-template-input .target-add-btn{min-width:6rem}#other-user-template-input .target-names .target-name{color:#008ca0;background-color:#fff;min-height:2.3rem!important;padding:2px 10px!important;margin:0 .5rem .5rem 0;border-radius:.25rem;border:1px solid #9b9b9b;word-break:break-all}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
